// Normalizes the backend's `{ msg }` / `{ error }` / `{ errors: [...] }` error
// shapes into a single display string. Mirrors the helper used in Login/Register.
export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.msg) return error.msg;
  if (error.error) return error.error;
  if (Array.isArray(error.errors) && error.errors[0]?.msg) return error.errors[0].msg;
  return fallback;
};
